<template>
  <div
    :class="{ 'sidebar-fullscreen': fullScreenSidebar }"
    class="sidebar sidebar-dark sidebar-main sidebar-expand-md"
  >
    <!-- Sidebar mobile toggler -->
    <div class="sidebar-mobile-toggler text-center">
      <a href class="sidebar-mobile-main-toggle" @click.prevent="onMobileClick">
        <i class="icon-arrow-left8"></i>
      </a>
      Navigation
      <a
        href
        class="sidebar-mobile-expand"
        @click.prevent="fullScreenSidebar = !fullScreenSidebar"
      >
        <i class="icon-screen-full"></i>
        <i class="icon-screen-normal"></i>
      </a>
    </div>
    <!-- /sidebar mobile toggler -->

    <!-- sidebar content -->
    <div class="sidebar-content">
      <slot name="header"></slot>

      <sidebar-menu
        :menu="menu"
        @on:click="$emit('on:item:click', $event)"
        @toggle-expand="$emit('toggle-expand', $event)"
      ></sidebar-menu>

      <slot name="footer"></slot>
    </div>
    <!-- /sidebar content -->
  </div>
</template>

<script>
import Sidebar from 'stylemix-vue-admin/components/sidebar/sidebar.vue'

export default {
  name: 'Sidebar',

  extends: Sidebar,
}
</script>
